// store/modules/preview_route.js

const state = {
  globalString: '' // 전역 변수로 사용할 문자열
};

const mutations = {
  SET_GLOBAL_STRING(state, payload) {
    state.globalString = payload;
  }
};

const actions = {
  setGlobalString({ commit }, payload) {
    commit('SET_GLOBAL_STRING', payload);
  }
};

const getters = {
  globalString: state => state.globalString
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
